import { LicenseTypeEnum } from '../enums/license-type.enum';
import { LicenseStatusEnum } from '../enums/license-status.enum';
import { attribute } from '@awslabs-community-fork/dynamodb-data-mapper-annotations';
import { property } from '@pristine-ts/metadata';

export class LicenseModel {
  @attribute()
  @property()
  licenseType: LicenseTypeEnum;
  @attribute()
  @property()
  cancelAt?: Date;
  @attribute()
  @property()
  status: LicenseStatusEnum;
  @attribute()
  @property()
  isFreeTrial: boolean;
  @attribute()
  @property()
  trialEnd?: Date;
  @attribute()
  @property()
  currentCycleEnd?: Date;
}
